/*
 * Created ADDRESS_FIELD_1_ATTRIBUTE_KEY and ADDRESS_FIELD_3_ATTRIBUTE_KEY constants
 */

export * from '@/core/data/constants/addressFields';

export const ADDRESS_FIELD_1_ATTRIBUTE_KEY = 'addressField1';
export const ADDRESS_FIELD_3_ATTRIBUTE_KEY = 'addressField3';
